import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2a438532&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a438532')) {
      api.createRecord('2a438532', component.options)
    } else {
      api.reload('2a438532', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2a438532&", function () {
      api.rerender('2a438532', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orders/allocation_windows/index.vue"
export default component.exports